import * as CoreActions from '@common/_store/core.actions';

import {createReducer, on} from '@ngrx/store';
import {BrokerUserProfile} from '../../../../services/broker/model/brokerUserProfile';

export const coreStateFeatureKey = 'coreState';

export interface CoreState {
    cabinetId?: string,
    tabId?: string,
    accessToken?: string,
    deviceId?: string,
    userProfile?: BrokerUserProfile,
    pageTitle?: string,
}

export const coreReducer = createReducer(
    {} as CoreState,

    on(CoreActions.SetTabId, (state, action) => ({
        ...state,
        tabId: action.tabId
    })),

    on(CoreActions.SetCurrentId, (state, action) => ({
        ...state,
        cabinetId: action.id
    })),

    on(CoreActions.SetTokenSuccess, (state, action) => ({
        ...state,
        accessToken: action.payload.accessToken,
        deviceId: action.payload.deviceId
    })),

    on(CoreActions.LoadUserProfileSuccess, (state, action) => ({
        ...state,
        userProfile: action.payload
    })),

    on(CoreActions.SetPageTitle, (state, action) => ({
        ...state,
        pageTitle: action.payload
    })),

    on(CoreActions.EditProfile, (state, action) => ({
        ...state,
        userProfile: {
            ...state.userProfile,
            ...action.payload.name && { name: action.payload.name },
            ...action.payload.phone && { phone: action.payload.phone },
            ...action.payload.layout && { layoutType: action.payload.layout }
        }
    })),

    on(CoreActions.LogOutSuccess, () => ({}))
);


